import React from 'react';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import s from './Contact.css';

const Contact = ({ title }) => {
  return (
    <div className={s.root}>
      <div className={s.container}>
        <h1>{title}</h1>
        <p>...</p>
      </div>
    </div>
  );
};

Contact.propTypes = {
  title: PropTypes.string.isRequired,
};

export default withStyles(s)(Contact);
